export const styles = {
  form: "flex flex-col w-full space-y-2 text-black",
  input: "border rounded-lg focus:ring-blue-400",
  pwInputContainer: "flex border rounded-lg",
  pwInput:
    "w-full bg-transparent border-0 rounded-lg focus:ring-0 focus:border-none",
  eyeIcon: "text-gray-500 hover:text-black hover:cursor-pointer",
  eyeIconContainer: "flex flex-col items-center justify-center w-16",
  adminSelect:
    "text-purple-500 bg-purple-100 border-2 border-purple-500 rounded-lg focus:border-purple-500 focus:ring-purple-500",
  submitBtn: "px-6 py-1.5 text-white bg-blue-500 rounded-lg hover:bg-blue-600",
  footer: "flex justify-end w-full space-x-2",
  cancelBtn:
    "px-6 py-1.5 border border-blue-500 rounded-lg text-blue-500 hover:bg-red-500 hover:text-white hover:border-red-500",
};
